document.addEventListener('DOMContentLoaded', () => {
  const root = window.Shopify?.routes?.root || '/';

  document
    .querySelectorAll('form[action*="/cart/add"]:not(.fm-product-form)')
    .forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[type="submit"]');
        const originalLabel = button?.textContent || '';

        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }

        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });

          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(
              data.description ||
              data.message ||
              'The selected item could not be added.'
            );
          }

          window.location.assign(root + 'cart');
        } catch (error) {
          const status =
            form.querySelector('[role="alert"]') ||
            document.createElement('p');

          status.setAttribute('role', 'alert');
          status.textContent =
            error?.message ||
            'The selected item could not be added. Please try again.';

          if (!status.isConnected) form.appendChild(status);

          if (button) {
            button.disabled = false;
            button.textContent = originalLabel;
          }
        }
      });
    });
});
